import { render, staticRenderFns } from "./StreamingMethod.vue?vue&type=template&id=61b13296&"
import script from "./StreamingMethod.vue?vue&type=script&lang=ts&"
export * from "./StreamingMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports